import { IChartApi, ISeriesApi } from "lightweight-charts";

export function SetChartZoomBasedOnViewport(
    lineSeries: ISeriesApi<any>,
    chart: IChartApi
) {
    const data = lineSeries.data();
    const lastIndex = data.length - 1;

    // Get viewport width in pixels
    const viewportWidth =
        document.getElementById("stateProgress_container")?.clientWidth || 800;

    // Calculate the number of data points to show based on viewport width
    // Assuming a rough estimate of 4 pixels per data point
    const visiblePoints = Math.floor(viewportWidth / 4);
    const fromIndex = Math.max(0, lastIndex - visiblePoints);

    // Define a visible range using time points
    const from = data[fromIndex].time;
    const to = data[lastIndex].time;

    chart.timeScale().setVisibleRange({ from, to });
}
